import angular from 'angular'
angular.module('pub.comments.service', []).factory('CommentsService', CommentsService)

/** @ngInject */
function CommentsService($http, $q, API) {
  function get(parentId, start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL +
          'publisher/posts/' +
          parentId +
          '/comments?start=' +
          start +
          '&limit=' +
          limit,
      )
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function save(model) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + 'publisher/comments', model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function update(id, model) {
    var defered = $q.defer()

    $http
      .put(API.API_URL + 'publisher/comments/' + id, model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function remove(id) {
    var defered = $q.defer()

    $http
      .delete(API.API_URL + 'publisher/comments/' + id)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function report(id) {
    var defer = $q.defer()

    $http
      .post(API.API_URL + 'publisher/comments/' + id + '/report')
      .success(defer.resolve)
      .error(defered.reject)

    return defer.promise
  }

  function hide(id) {
    var defer = $q.defer()

    $http
      .post(API.API_URL + 'publisher/comments/' + id + '/hide')
      .success(defer.resolve)
      .error(defered.reject)

    return defer.promise
  }

  return {
    get: get,
    save: save,
    update: update,
    remove: remove,
    report: report,
    hide: hide,
  }
}
